<div class="app-container" #scrollMe>
    <app-loading></app-loading>
    <router-outlet></router-outlet>
</div>